import React from 'react';
import { Banner } from '../../components';
import s from './HostStyles.module.scss';

const BannerHost = () => (
    <div className={s.editor} style={{ padding: '100px' }}>
        <Banner banner={{ message: 'green success', color: 'green', icon: 'icon-circle-check', isVisible: true }} />
        <br />
        <br />
        <Banner banner={{ message: 'red error', color: 'red', icon: 'icon-error', isVisible: true }} />
        <br />
        <br />
        <Banner banner={{ message: 'blue running', color: 'blue', icon: 'icon-fluidloader', isVisible: true }} />
        <br />
        <br />
    </div>
);

export default BannerHost;
